import * as React from 'react';

import { ActivityType } from '@showbie-socrative/socrative-utils';

function useIsQuickQuestion(activityType: ActivityType): boolean {
  return React.useMemo(() => {
    switch (activityType) {
      case ActivityType.NoReport:
      case ActivityType.QuickQuestionShortAnswer:
      case ActivityType.Vote:
        return true;
      default:
        return false;
    }
  }, [activityType]);
}

export { useIsQuickQuestion };
